import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.0_@playwright+test@1.57.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/common/components/localized-client-link/index.tsx");
